import React, { useState } from 'react'
import { Eye, EyeOff, Loader } from 'lucide-react'
import toast from 'react-hot-toast'
import { vendorService } from '../../../services/authService'

const PasswordUpdateForm = () => {
  const [oldPassword, setOldPassword] = useState('')
  const [newPassword, setNewPassword] = useState('')
  const [confirmPassword, setConfirmPassword] = useState('')
  const [showOld, setShowOld] = useState(false)
  const [showNew, setShowNew] = useState(false)
  const [showConfirm, setShowConfirm] = useState(false)
  const [isLoading, setIsLoading] = useState(false)

  const handleUpdate = async () => {
    if (!oldPassword) {
      toast.error('Please enter your current password')
      return
    }
    if (!newPassword || newPassword.length < 8) {
      toast.error('New password must be at least 8 characters')
      return
    }
    if (newPassword !== confirmPassword) {
      toast.error('Passwords do not match')
      return
    }

    setIsLoading(true)
    try {
      const resp = await vendorService.updatePassword({
        old_password: oldPassword,
        password: newPassword,
        confirm_password: confirmPassword,
      })
      if (resp.success) {
        toast.success(resp.message || 'Password updated successfully')
        setOldPassword('')
        setNewPassword('')
        setConfirmPassword('')
      } else {
        toast.error(resp.message || 'Failed to update password')
      }
    } catch (err) {
      toast.error(err.message || 'Failed to update password')
    } finally {
      setIsLoading(false)
    }
  }

  return (
    <div className="space-y-3">
      <div>
        <label className="label block mb-2">Current password</label>
        <div className="relative">
          <input
            type={showOld ? 'text' : 'password'}
            value={oldPassword}
            onChange={(e) => setOldPassword(e.target.value)}
            className="input pr-10"
            placeholder="Enter current password"
          />
          <button type="button" onClick={() => setShowOld(!showOld)} className="absolute right-3 top-1/2 transform -translate-y-1/2 text-secondary-400 hover:text-secondary-600">
            {showOld ? <EyeOff className="w-5 h-5" /> : <Eye className="w-5 h-5" />}
          </button>
        </div>
      </div>

      <div>
        <label className="label block mb-2">New password</label>
        <div className="relative">
          <input
            type={showNew ? 'text' : 'password'}
            value={newPassword}
            onChange={(e) => setNewPassword(e.target.value)}
            className="input pr-10"
            placeholder="Enter new password"
          />
          <button type="button" onClick={() => setShowNew(!showNew)} className="absolute right-3 top-1/2 transform -translate-y-1/2 text-secondary-400 hover:text-secondary-600">
            {showNew ? <EyeOff className="w-5 h-5" /> : <Eye className="w-5 h-5" />}
          </button>
        </div>
        {newPassword && newPassword.length < 8 && (
          <p className="text-error-500 text-sm mt-1">Password must be at least 8 characters</p>
        )}
      </div>

      <div>
        <label className="label block mb-2">Confirm new password</label>
        <div className="relative">
          <input
            type={showConfirm ? 'text' : 'password'}
            value={confirmPassword}
            onChange={(e) => setConfirmPassword(e.target.value)}
            className="input pr-10"
            placeholder="Confirm new password"
          />
          <button type="button" onClick={() => setShowConfirm(!showConfirm)} className="absolute right-3 top-1/2 transform -translate-y-1/2 text-secondary-400 hover:text-secondary-600">
            {showConfirm ? <EyeOff className="w-5 h-5" /> : <Eye className="w-5 h-5" />}
          </button>
        </div>
        {confirmPassword && confirmPassword !== newPassword && (
          <p className="text-error-500 text-sm mt-1">Passwords do not match</p>
        )}
      </div>

      <div>
        <button
          type="button"
          onClick={handleUpdate}
          className="btn btn-primary w-full py-3"
          disabled={isLoading || !oldPassword || newPassword !== confirmPassword || newPassword.length < 8}
        >
          {isLoading ? (
            <>
              <Loader className="w-4 h-4 animate-spin mr-2" />
              Updating...
            </>
          ) : (
            'Update password'
          )}
        </button>
      </div>
    </div>
  )
}

export default PasswordUpdateForm
